import Swiper from 'swiper/js/swiper';

const initSliderItemsSwiper = () => {

  const $sections = document.querySelectorAll('.section-items[data-cms="list/slider-items"]');

  $sections.forEach(section => {
    const $swiperSlider = section.querySelector('.js-swiper-slider-items .swiper-container');
    const slides = section.querySelectorAll('.swiper-slide');

    const swiper = new Swiper($swiperSlider, {
      slidesPerView: 1,
      loop: false,
      speed: 500,
      simulateTouch: false,
      preloadImages: false,
      spaceBetween: 20,
      lazy: {
        loadPrevNext: true,
      },
      navigation: {
        prevEl: section.querySelector('.js-paging-prev'),
        nextEl: section.querySelector('.js-paging-next'),
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        }
      },
    }
  );
  
    swiper.init();
    initSlider()
    addEventListener('resize', () => {setTimeout(() => {initSlider()}, 100);});
    
    function initSlider() {
      if(window.innerWidth < 768) {
        if(slides.length == 1) {
          section.querySelector('.js-swiper-slider-items')?.classList.add('not-initialized', 'single-item');
        } else {
          section.querySelector('.js-swiper-slider-items')?.classList.remove('not-initialized');
        }
      }else {
        if(slides.length == 1) {
          section.querySelector('.js-swiper-slider-items')?.classList.add('not-initialized', 'single-item');
        }else if(slides.length > 3) {
          section.querySelector('.js-swiper-slider-items')?.classList.remove('not-initialized');
        }else {
          section.querySelector('.js-swiper-slider-items')?.classList.add('not-initialized');
        }
      }
    } 

  })
}
 
export default initSliderItemsSwiper;


